import React, { useEffect, useRef, useState,useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate, useSearchParams } from 'react-router-dom';
import {
  Table,
  Button
} from 'react-bootstrap';
import { currencyFormatter } from '../../../utils/services';
import { list_card_opportunities, save_new_stgy_split } from '../../../utils/crm_services';
import Select from 'react-select';





function StrategyPage  ({usr_id, permission, usr_type, channel_id = '', channel_name = ''}) {

    const token = localStorage.getItem("token");

  
    const [initialRows, setInitialRows] = useState([]);
    const [strategyName, setStrategyName] = useState('');
     const [strategyShortURL, setStrategyShortURL] = useState('');
    const [totalAmount, settotalAmount] = useState(0);
    const [totalPorcentage, setTotalPorcentage] = useState(0);
    const [totalCost, setTotalCost] = useState(0);
    const [searchParams] = useSearchParams();
    const card_id = searchParams.get("cardid");

 

    const navigate = useNavigate();   
    
          const stageOptions = [
        { label: '5%', value: 0.05 },
        { label: '10%', value: 0.1 },
        { label: '15%', value: 0.15 },
        { label: '20%', value: 0.2 },
        { label: '25%', value: 0.25 },
        { label: '30%', value: 0.3 },
        { label: '35%', value: 0.35 },
        { label: '40%', value: 0.4 },
        { label: '45%', value: 0.45 },
        { label: '50%', value: 0.5 },
        { label: '55%', value: 0.55 },
        { label: '60%', value: 0.6 },
        { label: '65%', value: 0.65 },
        { label: '70%', value: 0.7 },
        { label: '75%', value: 0.75 },
        { label: '80%', value: 0.8 },
        { label: '85%', value: 0.85 },
        { label: '90%', value: 0.9 },
        { label: '95%', value: 0.95 },
        { label: '100%', value: 1 },
      ];
    

    
    
    useEffect(() => {
          if(card_id)
            fetchlistOpportunities();
          }, [card_id]); 
  

          
  async function saveSplit(id, value) {
      console.log("saveSplit", id, value);

      const opportunityList = await save_new_stgy_split(token, id, value);
      if (opportunityList==="INVALID"){
          navigate("/");
      }else{
          fetchlistOpportunities();
        
      }
  }

    async function fetchlistOpportunities() {
            const opportunityList = await list_card_opportunities(token, card_id);
            if (opportunityList==="INVALID"){
                navigate("/");
            }else{
             
       
     
              let SUM_AMOUNT = 0;
              let SUM_COST = 0;
              let SUM_PORCENTAGE = 0;
              const tempList= opportunityList["opp_data"].map((celement, index) => {
              
                SUM_AMOUNT += parseFloat(celement.dollar_amount);
                SUM_COST += parseFloat(celement.cardCost);
                SUM_PORCENTAGE += parseFloat(celement.porcentage);
                return {
                  id: celement.id,
                  id_relation: celement.id_relation,
                  opportunitieName: celement.name,
                  cardCost: (celement.cardCost),
                  porcentage: (celement.porcentage),
                  moneyAmount: (celement.dollar_amount),
                  index:index
                };
              });

              settotalAmount(SUM_AMOUNT);
              setTotalCost(SUM_COST);
              setTotalPorcentage(SUM_PORCENTAGE);


              const stgyList= opportunityList["stgy_data"].map((celement, index) => ({
                  id: celement.id,
                  title: celement.title,
                  shortURL: celement.shortURL,
                  index
                }));

              
              setStrategyShortURL(stgyList[0].shortURL);
              setStrategyName(stgyList[0].title);
              setInitialRows(tempList);
              
            }
          }

      const getStageByValue = (value) => {
        console.log("getStageByValue", value);
        return stageOptions.find(option => option.value ===Number( value));
      };



          
          
    // ---------- UI ----------
    return (
      <div className="container-flex py-4 px-4">

      <div className="d-flex justify-content-left align-items-center mb-4">
        <h4 className="fw-bold mb-0">Strategy Name: </h4>
        <h4 className=" mb-0 px-1"> <a href={strategyShortURL} target='_blank'> {strategyName}</a> </h4>
      
       
      
        </div>
        {/* Barra de búsqueda + menús */}
        

        {/* Tabla */}
        <Table hover responsive className="align-middle">
          <thead className="table-light">
            <tr>

            
                <th  role="button">
                  Opportunity Name
                </th>
      
             
              {parseInt(usr_type)==0 && (
                <th role="button">
                  Cost 
                </th>
              )}
             
              {parseInt(usr_type)==0 && (
                <th  role="button">
                  Amount
                </th>
              )}

           
                <th role="button">
                  Split 
                </th>
          
              
            </tr>
          </thead>
          <tbody>
            {initialRows.map((row) => {
              
              const getRowClassName = (status) => {
                if (status == 0) { // Por validar
                  return 'table-danger'; // Clase de Bootstrap para un fondo rojo claro
                } else if (status == 4) { // Ejemplo de estado
                  return 'table-secondary'; // Clase de Bootstrap para un fondo gris
                } else if (status == 2) { // Ejemplo de estado
                  return 'table-success'; // Clase de Bootstrap para un fondo verde claro
                } else if (status == 3) { // Ejemplo de estado
                  return 'table-warning'; // Clase de Bootstrap para un fondo amarillo/naranja claro
                }
                return ''; // Sin clase adicional
                };

              return(
              <tr key={row.id}  className={getRowClassName(parseInt(row.current_status))}>

                <td onClick={() => navigate(`/opportunitypage?id=${row.id}`) } >{row.opportunitieName} </td>
                {parseInt(usr_type)==0 && <td>{currencyFormatter.format(row.cardCost)}</td>}
                {parseInt(usr_type)==0 && <td>{currencyFormatter.format( row.moneyAmount)}</td>}
                <td>
                    <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={stageOptions}
                        isLoading={stageOptions.length === 0}
                        onChange={(selectedOption) => {
                            saveSplit(row.id_relation, selectedOption.value);
                        }}
                        placeholder="Porcentage..."
                        value={getStageByValue(row.porcentage)}
                        // AGREGAMOS ESTA PROPIEDAD:
                        menuPortalTarget={document.body}
                        styles={{
                            container: (provided) => ({
                                ...provided,
                                minWidth: 100,
                                flex: 1,
                            }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                            }),
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999, // Este zIndex ahora es muy efectivo ya que el portal está en el body
                            }),
                        }}
                    />
                </td>
              </tr>
            )})}

             <tr key={1000}  >

                <td></td>
                {parseInt(usr_type)==0 && <td>{currencyFormatter.format(totalCost)}</td>}
                {parseInt(usr_type)==0 && <td>{currencyFormatter.format( totalAmount)}</td>}
                <td style={totalPorcentage > 1 ? { color: 'red', fontWeight: 'bold' } : {}}>
                  {totalPorcentage * 100 + "%"}
                </td>
                 
       
              </tr>
            {initialRows.length === 0 && (
              <tr>
                <td colSpan="10" className="text-center py-4">
                  No results
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
};

export default StrategyPage;
